import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import { GroupsAppManager } from 'apps/group/appManager';
import { GroupSection } from 'apps/group/views/groupSection';
import { LinkSection } from 'apps/group/views/linkSection';

@inject('routerStore')
@observer
export class TeamSettings extends React.Component {
  UNSAFE_componentWillMount() {
    this.groupsManager = new GroupsAppManager(null, this.props);
  }

  render() {
    const { groupsManager } = this.props;
    const groupsList = groupsManager.groups?.groupsDistinctMembers;
    const groups =
      Array.isArray(groupsList) &&
      groupsList.map(group => (
        <GroupSection
          group={group}
          key={group.id}
          project={this.props.projectManager.project}
        />
      ));

    return (
      <>
        <LinkSection app={groupsManager.inviteLink} type='project' />
        {groups}
      </>
    );
  }
}

TeamSettings.propTypes = {
  projectManager: PropTypes.object,
  groupsManager: PropTypes.object,
};
